module.exports = __webpack_public_path__ + "img/logo_reg_serv.14640709.png";